import { DatePipe, NgClass } from '@angular/common';
import { Component, computed, inject, input, LOCALE_ID } from '@angular/core';
import { BundleDetails } from '../../../../../../pages/admin-dashboard/promotions/bundles-managment/bundles.model';
import { LookupVTO } from '../../../../../../pages/admin-dashboard/admin-companies/admin-companies.model';
import { DateTimePipe } from '../../../../../../shared/utils/date-time.pipe';

@Component({
  selector: 'app-bundle-details-tab',
  imports: [DatePipe, NgClass, DateTimePipe],
  templateUrl: './bundle-details-tab.html',
  styleUrl: './bundle-details-tab.scss',
})
export class BundleDetailsTab {
  private locale = inject(LOCALE_ID);
  isArabic = computed(() => this.locale.startsWith('ar'));
  bundle = input.required<BundleDetails>();

  getStatusClass(bundleStatus: LookupVTO) {
    const id = bundleStatus?.id;
    if (id === 1) return 'bg-green-100 text-green-700';
    if (id === 2) return 'bg-red-100 text-red-700';
    if (id === 3) return 'bg-gray-100 text-gray-500';
    return '';
  }
}
